"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsNullOrUndef_1 = __importDefault(require("../typeAssertions/valueIsNullOrUndef"));
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const getDbPathFromArrayOfValues = (arrayPath) => {
    if ((0, valueIsString_1.default)(arrayPath)) {
        return arrayPath;
    }
    if (!(0, valueIsArray_1.default)(arrayPath)) {
        throw new Error('Db path should be an array of links');
    }
    const pathOnDb = arrayPath.join('/');
    const invalidLinks = arrayPath.filter((link) => (0, valueIsNullOrUndef_1.default)(link));
    if (invalidLinks.length > 0) {
        throw new Error(`The db path should not contain null or undefined links: ${pathOnDb}`);
    }
    return pathOnDb;
};
exports.default = getDbPathFromArrayOfValues;
